import Env from "./env"
export const getScatterSeries = (
  name: string,
  list: any[],
  color = "#FF5555",
  showLabel = true
) => {
  let max = 1
  let min = 9999999999999
  let numSet = new Set<number>()
  let data = list.map((item) => {
    min = Math.min(min, item.count)
    let n = item.count //|| 1
    numSet.add(n)
    let coord = item.coord || item.center
    return {
      name: item.name,
      value: [item.lon || coord[0], item.lat || coord[1], n],
    }
  })
  let nums: number[] = Array.from(numSet).sort((a: number, b: number) => {
    return a - b
  })
  return {
    name: name,
    type: "effectScatter",
    coordinateSystem: "amap",
    zlevel: 2,
    rippleEffect: {
      brushType: "stroke",
    },
    label: {
      normal: {
        show: showLabel,
        position: "bottom",
        formatter: "{b}",
        color: "#ffffff",
        fontSize: 12 * Env.getScale(),
      },
    },
    symbolSize: function (val) {
      return (
        (val[2] ? ((nums.indexOf(val[2]) + 1) / nums.length) * 30 : 10) *
        Env.getScale()
      )
    },
    itemStyle: {
      color: color,
      // opacity: 0.5,
    },
    data: data,
  }
}
var planePath =
  "path://M1705.06,1318.313v-89.254l-319.9-221.799l0.073-208.063c0.521-84.662-26.629-121.796-63.961-121.491c-37.332-0.305-64.482,36.829-63.961,121.491l0.073,208.063l-319.9,221.799v89.254l330.343-157.288l12.238,241.308l-134.449,92.931l0.531,42.034l175.125-42.917l175.125,42.917l0.531-42.034l-134.449-92.931l12.238-241.308L1705.06,1318.313z"
export const getFlyLineSeries = (
  name: string,
  list: any[],
  color = "#a6c84c",
  icon = false,
  period = 7
) => {
  let data = list.map((item) => {
    let { fromName, toName, coords, count, name } = item
    return {
      fromName,
      toName,
      coords,
      value: count,
      name,
    }
  })
  let constantSpeed = 0
  // let period = 0
  let delay = 0
  let opt: any[] = [
    {
      name: name,
      type: "lines",
      zlevel: 3,
      coordinateSystem: "amap",
      effect: {
        show: true,
        period,
        constantSpeed,
        trailLength: 0.1,
        color: "#fff",
        symbolSize: 3,
        delay,
      },

      lineStyle: {
        normal: {
          color: color,
          width: 0,
          curveness: 0.2,
        },
      },
      data: data,
    },

    {
      name: name + "_1",
      type: "lines",
      zlevel: 4,
      coordinateSystem: "amap",
      // label: {
      //   show: true,
      //   position: "middle",
      //   formatter: (item) => {
      //     return item.name
      //   },
      // },
      effect: {
        show: true,
        period,
        constantSpeed,
        trailLength: 0,
        symbol: planePath,
        symbolSize: 0,
        delay,
      },
      lineStyle: {
        normal: {
          color: color,
          width: 2,
          opacity: 0.4,
          curveness: 0.2,
        },
      },
      data: data,
    },
  ]
  if (icon) {
    opt[1].effect.symbol = planePath
    opt[1].effect.symbolSize = 15
  }
  return opt
}
